import router from '../../router';
import configClient from '../../Services/configClient';

const state = () => ({
    config: {},
})

const mutations = {
    setConfig(state, payload) {
        state.config = payload;
    }
}

const actions = {
    setEntityConfiguration({commit}) {
        const storedEntityCode = sessionStorage.getItem('codNrbeEn');
        const configFileName = window.location.hostname;

        if (!storedEntityCode || storedEntityCode == 'undefined') {
            configClient.get(`${process.env.VUE_APP_CONFIG_PATH}${configFileName}.json`).then(response => {
                commit('setConfig', response.data);
                sessionStorage.setItem('codNrbeEn', response.data.codNrbeEn);
            }).catch(error => {
                console.error(error);
                router.app.$router.push({ name: 'ErrorConfigEntity' })
            })
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
}